import eventAction from "@/store/eventAction";

import cache from "@/store/cache";

function defaultState() {
  return {
    loaded: false
  };
}
// state
const state = defaultState();

// getters
const getters = {};

// actions
const actions = {
  clear({ state }) {
    Object.assign(state, defaultState());
  },
  socket_fieldsInt({ commit }, data) {
    if (data.board_fields) {
      for (var i = 0; i < data.board_fields.length; i++) {
        const board_field = data.board_fields[i];
        commit("ADD_BOARD", {
          board: cache.boards.byId(board_field.board_id),
          field: board_field
        });
      }
    }

    if (data.card_fields) {
      commit(
        "ADD_RANGE_CARD",
        data.card_fields.map(field => {
          return {
            boardField: cache.boardFieldsInt.byId(field.board_field_id),
            card: cache.cards.byId(field.card_id),
            field: field
          };
        })
      );
    }

    state.loaded = true;
  },

  new({ dispatch }, { board, description, suffix, show_total, show_on_card }) {
    dispatch(
      "events/emit",
      {
        action: eventAction.board.field.new,
        board: board,
        data: description,
        data2: suffix,
        param2: show_total ? 1 : 0,
        param3: show_on_card ? 1 : 0
      },
      { root: true }
    );
  },

  edit({ dispatch }, { field, description, suffix, show_total, show_on_card }) {
    dispatch(
      "events/emit",
      {
        action: eventAction.board.field.edit,
        board: cache.boards.byId(field.board_id),
        data: description,
        data2: suffix,
        param1: field.id,
        param2: show_total ? 1 : 0,
        param3: show_on_card ? 1 : 0
      },
      { root: true }
    );
  },

  newCard({ dispatch }, { boardField, card, value }) {
    dispatch(
      "events/emit",
      {
        action: eventAction.card.fieldInt.new,
        card: card,
        data: value,
        param1: boardField.id
      },
      { root: true }
    );
  },

  editCard({ dispatch }, { field, value }) {
    dispatch(
      "events/emit",
      {
        action: eventAction.card.fieldInt.edit,
        card: cache.cards.byId(field.card_id),
        data: value,
        param1: field.id
      },
      { root: true }
    );
  },

  handleEvent({ rootState, commit }, event) {
    const requirements = eventAction.requireFor(rootState, event);
    if (!requirements) return;

    switch (event.action) {
      case eventAction.board.field.new: {
        const newBoardField = {
          id: event.param1,
          board_id: requirements.board.id,
          description: event.data,
          suffix: event.data2,
          show_total: !!event.param2,
          show_on_card: !!event.param3
        };

        commit("ADD_BOARD", {
          board: requirements.board,
          field: newBoardField
        });
        break;
      }
      case eventAction.board.field.edit: {
        const editBoardField = {
          id: event.param1,
          board_id: requirements.board.id,
          description: event.data,
          suffix: event.data2,
          show_total: !!event.param2,
          show_on_card: !!event.param3
        };

        commit("ADD_BOARD", {
          board: requirements.board,
          field: editBoardField
        });
        break;
      }
      case eventAction.card.fieldInt.new: {
        let value = 0;
        if (event.data) {
          value = parseFloat(event.data);
          if (!value) {
            value = 0;
          }
        }
        const newField = {
          id: event.param2,
          board_field_id: event.param1,
          card_id: requirements.card.id,
          value: value
        };

        commit("ADD_CARD", {
          boardField: cache.boardFieldsInt.byId(event.param1),
          card: requirements.card,
          field: newField
        });
        break;
      }
      case eventAction.card.fieldInt.edit: {
        const cardField = requirements.card.fields.find(f => f.id == event.param1);
        if (event.data) {
          cardField.value = parseFloat(event.data);
        } else {
          cardField.value = 0;
        }
        break;
      }
    }
  }
};

function addCard(state, boardField, card, field) {
  if (!field) return;

  if (!field.id) {
    console.error("Cant add card_field without id", field);
    return;
  }

  if (!boardField) {
    console.error("board_field is not existing for card_field", field);
    return;
  }

  if (!card) {
    console.error("card is not existing for card_field", field);
    return;
  }

  if (card.fields.find(f => f.id == field.id)) {
    //already laoded
    return;
  }

  if (!field.card_id) {
    field.card_id = card.id;
  }

  if (!field.board_field_id) {
    field.board_field_id = boardField.id;
  }

  field.boardField = boardField;
  if (!card.fields.find(f => f.id == field.id)) {
    card.fields.push(field);
  }
}

// mutations
const mutations = {
  ADD_BOARD(state, { board, field }) {
    if (!field) return;

    if (!field.id) {
      console.error("Cant add board_field without id", field);
      return;
    }

    if (!board) {
      console.error("board is not existing for board_field", field);
      return;
    }

    if (!field.board_id) field.board_id = board.id;
    if (!field.description) field.description = "";
    if (!field.suffix) field.suffix = "";

    const existing = board.fields.find(f => f.id == field.id);
    if (existing) {
      existing.description = field.description;
      existing.suffix = field.suffix;
      existing.show_total = field.show_total;
      existing.show_on_card = field.show_on_card;
    } else {
      board.fields.push(field);
    }
  },

  ADD_RANGE_CARD(state, items /* [{ boardField, card, field }] */) {
    items.forEach(i => {
      addCard(state, i.boardField, i.card, i.field);
    });
  },

  ADD_CARD(state, { boardField, card, field }) {
    addCard(state, boardField, card, field);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
